import React, { useState } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import { Box, Stack, TablePagination } from '@mui/material';
import Draggable from 'react-draggable';
import SearchButton from '../components/SearchButton';
import PlayersPanel from './PlayersPanel';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#player-list-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

export default function PlayerSelectDialog({ onSelect, onClose }) {

    const [players, setPlayers] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [itemCount, setItemCount] = useState(0);
    const [search, setSearch] = useState('');
    const [textFieldDirty, setTextFieldDirty] = useState(true);
    const [loading, setLoading] = useState(false);

    const loadData = async (page, rowsPerPage, search) => {
        setLoading(true);
        const params = new URLSearchParams({
            pageNumber: page,
            itemsPerPage: rowsPerPage,
            text: search,
        });
        const response = await axios.get(`/player?${params.toString()}`);
        setPlayers(response.data.items);
        setPage(response.data.pageNumber);
        setRowsPerPage(response.data.itemsPerPage);
        setItemCount(response.data.totalItems);
        setLoading(false);
        setTextFieldDirty(false);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setTextFieldDirty(true);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (!textFieldDirty && players.length === 1) {
                onSelect(players[0]);
            } else {
                onRefresh();
                setTextFieldDirty(false);
            }
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        loadData(newPage, rowsPerPage, search);
    };

    const handleChangeRowsPerPage = (event) => {
        const value = parseInt(event.target.value, 10);
        setRowsPerPage(value);
        setPage(0);
        loadData(0, value, search);
    };

    const onRefresh = () => {
        loadData(page, rowsPerPage, search);
    };

    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="player-list-title"
            scroll={"paper"}
            open={true}
            fullWidth
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                },
            }}
        >
            <Toolbar id="player-list-dialog-toolbar" sx={{ m: 0, p: 0, display: 'flex' }}>
                <DialogTitle id="player-list-dialog-title" sx={{ cursor: 'move' }}>Player Search</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                        marginLeft: 'auto',
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Toolbar>
            <DialogContent sx={{
                p: 0,
                ml: 2,
                mr: 2,
                display: 'flex',
                flexDirection: 'column'
            }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, height: '100%' }}>
                    <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                        <TextField
                            autofocus
                            label="Search"
                            variant="standard"
                            value={search}
                            size='small'
                            onChange={handleSearchChange}
                            onKeyDown={handleKeyPress}
                            sx={{ flex: 1 }}
                        />
                        <SearchButton onClick={onRefresh} />
                    </Stack>
                    <PlayersPanel players={players} onSelect={onSelect} loading={loading} />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                        <TablePagination
                            component="div"
                            count={itemCount}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{ overflow: 'hidden' }}
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
